import { Link } from 'react-router-dom';
import { ProfileMenu } from '../../../shared/ProfileMenu';
import { BusinessViewSwitcher } from '../../../shared/BusinessViewSwitcher';
import { ThemeToggle } from '../../../shared/theme/ThemeToggle';

/** The business-profile / user-profile header — reproduces legacy's own SHARED layout header (confirmed
 * during investigation: `_Layout.cshtml`'s `business-switcher`/`user-profile-switcher`, not something
 * dashboard-specific). Company/role/name all come from the caller's own already-authenticated identity
 * context — never a client-editable value.
 *
 * Both the business switcher and the account menu are the SAME shared components AppShell's topbar uses
 * (see docs/business-view-switcher.md and docs/profile-menu-architecture.md for why one implementation of
 * each covers both hosts) — this is also the dashboard's only way back into the rest of the sidebar-based
 * app, via "Go to full app" below and ProfileMenu's own "My Profile"/other destinations, since this route
 * intentionally renders without a sidebar of its own.
 *
 * EPN-47 replaced this header's own bespoke "Switch business" indirection (trigger → tiny menu →
 * showCompanyPicker() → full-page CompanyPickerPage) with BusinessViewSwitcher's in-place popover — the
 * approved Business Profile Selection design shows the selectable company list directly in the header
 * dropdown, not a redirect to a separate page. "Go to full app" is unrelated navigation, not company
 * switching, so it stays as its own control rather than folding into the switcher. */
export function TopHeader() {
  return (
    <header className="ed-header">
      <div className="ed-header-business-row">
        <BusinessViewSwitcher />
        <Link to="/people" className="ed-header-full-app-link">
          Go to full app →
        </Link>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {/* EPN-46 — same placement/reuse rationale as AppShell.tsx's own topbar. */}
        <ThemeToggle />
        <ProfileMenu />
      </div>
    </header>
  );
}
